import _ from 'lodash';
import i18next from 'i18next';

import utilsXLS from '@commons/utils/makeXLS';

const ERROR_MESSAGES_BY_CODE = {
  404: 'NOT_EXIST_ERROR',
  422: 'NOT_BELONG_TO_CLIENT_ERROR',
  '200-price': 'PRICE_ERROR',
  '200-tva': 'VAT_RATE_ERROR',
  '200-loss': 'LOSS_ERROR',
  '200-price-tva': 'PRICE_AND_VAT_RATE_ERROR',
  '200-scheduled-price': 'SCHEDULED_PRICE_ERROR',
  '200-scheduled-start-date': 'SCHEDULED_START_DATE_ERROR',
  '200-scheduled-price-and-start-date': 'SCHEDULED_PRICE_AND_START_DATE_ERROR',
  '200-price-editable-at-reception': 'PRICE_EDITABLE_AT_RECEPTION_ERROR',
  '200-additional-prices': 'ADDITIONAL_PRICES_ERROR',
  '200-ean-13': 'EAN_13_ERROR',
  '200-invoice-packaging-name': 'INVALID_INVOICE_PACKAGING_NAME',
  '200-order-packaging-name': 'INVALID_ORDER_PACKAGING_NAME',
  '200-reception-packaging-name': 'INVALID_RECEPTION_PACKAGING_NAME',
  '200-shelf-life': 'INVALID_SHELF_LIFE',
  '200-shelf-life-central-kitchen': 'INVALID_SHELF_LIFE_CENTRAL_KITCHEN',
  '200-packaging': 'PACKAGINGS',
  '200-packaging-count': 'INVALID_PACKAGING_COUNT',
  '200-central-kitchen-validity': 'INVALID_CENTRAL_KITCHEN_VALIDITY',
  '200-conversions': 'INVALID_CONVERSIONS',
  '200-nutrition-facts': 'INVALID_NUTRITION_FACTS',
  '200-missing-conversion-for-associated-entity': 'MISSING_CONVERSION_FOR_ASSOCIATED_ENTITY',
};

const formatUnValidatedSupplierProductsForExport = (supplierProducts) =>
  supplierProducts.map((supplierProduct) => ({
    ...supplierProduct,
    error: i18next.t(
      `ADMIN.SUPPLIER_PRODUCTS.MODAL_IMPORT_TEMPLATE_EDIT_PRICE_EXPORT_${
        ERROR_MESSAGES_BY_CODE[supplierProduct.error] || 'UNKNOWN_ERROR'
      }`,
    ),
  }));

export const exportSupplierProductErrors = (data) => {
  const columns = [
    {
      propertyKey: 'supplierName',
      name: i18next.t('ADMIN.SUPPLIER_PRODUCTS.LIST_COLUMN_SUPPLIER'),
    },
    { propertyKey: 'name', name: i18next.t('GENERAL.NAME') },
    {
      propertyKey: 'category',
      name: i18next.t('ADMIN.SUPPLIER_PRODUCTS.LIST_COLUMN_CATEGORY'),
    },
    {
      propertyKey: 'subCategory',
      name: i18next.t('ADMIN.SUPPLIER_PRODUCTS.LIST_COLUMN_SUB_CATEGORY'),
    },
    { propertyKey: 'error', name: i18next.t('ADMIN.SUPPLIER_PRODUCTS.LIST_COLUMN_ERROR') },
  ];

  const sheet = utilsXLS.generateDefaultSheet(
    i18next.t('ADMIN.SUPPLIER_PRODUCTS.MODAL_IMPORT_TEMPLATE_EDIT_PRICE_EXPORT_SHEETNAME'),
    columns,
    formatUnValidatedSupplierProductsForExport(_.get(data, 'unValidated')),
  );

  utilsXLS.makeXLS(
    i18next.t('ADMIN.SUPPLIER_PRODUCTS.MODAL_IMPORT_TEMPLATE_EDIT_SUPPLIER_ITEMS_EXPORT_TITLE'),
    [sheet],
  );
};
